import { render, staticRenderFns } from "./TipsLayer.vue?vue&type=template&id=c1902b2a&scoped=true"
import script from "./TipsLayer.vue?vue&type=script&lang=js"
export * from "./TipsLayer.vue?vue&type=script&lang=js"
import style0 from "./TipsLayer.vue?vue&type=style&index=0&id=c1902b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1902b2a",
  null
  
)

export default component.exports